<template>
  <div>
    <h1>Server status: {{ status }}</h1>
    <button @click="changeStatus()">Change</button>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      status: 'critical'
    }
  },
  methods: {
    changeStatus() {
      this.status = 'normal'
    }
  }
}
</script>

<style >
</style>
